"use client"

import { useState } from "react"
import { useForm } from "react-hook-form"
import TextInput from "@components/forms/TextInput"
import Button from "@components/ui/Button"
import { Link } from "react-router"
import AlertBox from "@components/ui/AlertBox"
import { requestPasswordReset } from "../../services/passwordRecoveryService"

function RequestResetPasswordPage() {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm()
  const [message, setMessage] = useState({ type: "", text: "" })

  const onSubmit = async (data) => {
    setMessage({ type: "", text: "" })

    try {
      const response = await requestPasswordReset(data.email);
      if (response.error) {
        throw new Error(response.error);
      }

      setMessage({
        type: "success",
        text: "If an account exists with this email, you will receive password reset instructions.",
      })
    } catch (error) {      
      setMessage({
        type: "error",
        text: error.message || "Something went wrong. Please try again.",
      })
    }
  }

  return (
    <div className="min-h-[calc(100vh-100px)] bg-base-200 flex items-center justify-center p-4">
      <div className="card w-full max-w-md bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="card-title text-2xl font-bold text-center mx-auto">Forgot Password?</h2>
          <p className="text-center text-base-content/70 mt-2 mx-auto">
            Enter your email address and we'll send you instructions to reset your password.
          </p>

          <form onSubmit={handleSubmit(onSubmit)} className="mt-6 space-y-6">
            
            {message.text && (
              <AlertBox type={message.type} message={message.text} />
            )}

            <TextInput
              label="Email address"
              name="email"
              type="email"
              placeholder="name@example.com"
              register={register}
              errors={errors}
              validationRules={{ required: "Email is required" }}
            />

            <Button isLoading={isSubmitting} className="w-full">
              {isSubmitting ? "Sending Instructions..." : "Send Reset Instructions"}
            </Button>

            <div className="text-center">
              <Link to="/login" className="link link-hover text-sm">
                Back to login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default RequestResetPasswordPage;